import { render, staticRenderFns } from "./adminboard.vue?vue&type=template&id=95c0117a&scoped=true&"
import script from "./adminboard.vue?vue&type=script&lang=js&"
export * from "./adminboard.vue?vue&type=script&lang=js&"
import style0 from "./adminboard.vue?vue&type=style&index=0&id=95c0117a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c0117a",
  null
  
)

export default component.exports